// extracted by mini-css-extract-plugin
export default {"container":"FW-z","title":"GW-z","link":"HW-z"};